import React from 'react';
import { BoltIcon, BrainIcon, HeartIcon, DumbbellIcon } from 'lucide-react';
export function BenefitsSection() {
  return <section id="benefits" className="py-16 bg-white" data-id="element-17">
      <div className="container mx-auto px-4" data-id="element-18">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-19">
          WHAT THEY'VE STOLEN FROM YOU
        </h2>
        <div className="max-w-4xl mx-auto mb-12" data-id="element-20">
          <p className="mb-6 text-lg" data-id="element-21">
            Right now, as you're reading this, your testosterone is being
            systematically destroyed by forces you can't even see.
          </p>
          <p className="mb-6" data-id="element-22">
            Every sip of water from a plastic bottle floods your system with
            hormone-disrupting chemicals.
          </p>
          <p className="mb-6" data-id="element-23">
            Every bite of processed food delivers a cocktail of preservatives
            and additives designed to extend shelf life... while shortening
            yours.
          </p>
          <p className="mb-6" data-id="element-24">
            Every stressful day at your desk job triggers cortisol spikes that
            crush your testosterone production.
          </p>
        </div>
        <h3 className="text-2xl font-bold text-center mb-10" data-id="element-25">
          The Slow-Motion Robbery
        </h3>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-26">
          <div className="bg-gray-100 p-8 rounded-lg shadow-md" data-id="element-27">
            <div className="flex items-center mb-4" data-id="element-28">
              <BoltIcon className="text-red-600 mr-3" size={24} data-id="element-29" />
              <h4 className="text-xl font-bold" data-id="element-30">Your Energy</h4>
            </div>
            <p data-id="element-31">
              Remember when you could work all day and still have energy for the
              gym? For your family? For your wife? Now you're lucky if you can
              make it to 9 PM without feeling like you've been hit by a truck.
            </p>
          </div>
          <div className="bg-gray-100 p-8 rounded-lg shadow-md" data-id="element-32">
            <div className="flex items-center mb-4" data-id="element-33">
              <DumbbellIcon className="text-red-600 mr-3" size={24} data-id="element-34" />
              <h4 className="text-xl font-bold" data-id="element-35">Your Strength</h4>
            </div>
            <p data-id="element-36">
              Your muscles are shrinking. Your lifts are going down. No matter
              how hard you train, you can't build muscle like you used to. Your
              body is literally eating itself.
            </p>
          </div>
          <div className="bg-gray-100 p-8 rounded-lg shadow-md" data-id="element-37">
            <div className="flex items-center mb-4" data-id="element-38">
              <HeartIcon className="text-red-600 mr-3" size={24} data-id="element-39" />
              <h4 className="text-xl font-bold" data-id="element-40">Your Drive</h4>
            </div>
            <p data-id="element-41">
              Not just sexual drive (though that's dying too), but your drive
              for life. Your ambition. Your competitive fire. The part of you
              that used to attack challenges now just wants to hide from them.
            </p>
          </div>
          <div className="bg-gray-100 p-8 rounded-lg shadow-md" data-id="element-42">
            <div className="flex items-center mb-4" data-id="element-43">
              <BrainIcon className="text-red-600 mr-3" size={24} data-id="element-44" />
              <h4 className="text-xl font-bold" data-id="element-45">Your Confidence</h4>
            </div>
            <p data-id="element-46">
              You avoid mirrors. You wear loose clothes. You feel like a shadow
              of your former self. Other men seem stronger, more vital, more...
              masculine.
            </p>
          </div>
        </div>
        <div className="mt-16 max-w-4xl mx-auto bg-gray-900 text-white p-8 rounded-lg" data-id="element-47">
          <h3 className="text-2xl font-bold mb-6" data-id="element-48">The Point of No Return</h3>
          <p className="mb-6" data-id="element-49">
            Here's the terrifying truth: every month you wait, the harder it
            becomes to reverse.
          </p>
          <p className="mb-6" data-id="element-50">
            Your body is learning to live with less testosterone. Your Leydig
            cells (the cells that produce testosterone) are slowly dying off.
          </p>
          <p className="mb-6" data-id="element-51">
            Wait too long, and even the most powerful natural solutions won't be
            enough.
          </p>
          <p className="mb-6" data-id="element-52">
            You'll be forced into the Big Pharma trap: lifelong dependency on
            synthetic hormones, with all their side effects and risks.
          </p>
          <p className="text-xl font-bold" data-id="element-53">
            But it doesn't have to be this way...
          </p>
        </div>
      </div>
    </section>;
}